<template>
    <div class="product custom">
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>

        <div v-if="preview">
            <div v-if="type === 'api'">
                The future is now.
            </div>
        </div>

        <div v-if="!preview">
            The future is was last night.
        </div>
    </div>
</template>

<script>
import ProductMixin from "@/mixins/Product";

export default {
    mixins: [ProductMixin]
}
</script>